import { useQuery } from "@tanstack/react-query";
import React from "react";
import OurAllProjects from "../../components/our-all-projects";
import Spinner from "../../components/spinner";
import { BASE_URL } from "../../data/baseURL";
import { useScrollTop } from "../../hook/useScrollTop";

const OurProjects = () => {
  const { data, isLoading } = useQuery(["managementTeams"], async () => {
    const response = await window.fetch(`${BASE_URL}/management`);
    // const response = await window.fetch(`${BASE_URL}/management-teams`);
    return await response.json();
  });
  const management_team = data?.datas;

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <section className="me-13 ms-13 pt-5">
      <OurAllProjects />
    </section>
  );
};

export default OurProjects;
